/**
 * This is the Redux Store definition.
 *
 * It combines also the reducers - action located in this directory
 *
 * @author Pablo <pablo@gestionaleauto.com>
 */
import { configureStore } from '@reduxjs/toolkit';
import wizardReducer from './wizardSlice';
import lookupsReducer from './lookupsSlice';
import leadReducer from './leadSlice';

const getStore = (initialValues) => {
  const storeData = {
    reducer: {
      wizard: wizardReducer,
      lookups: lookupsReducer,
      lead: leadReducer,
    },
  };
  if (initialValues) {
    storeData.preloadedState = initialValues;
  }
  const store = configureStore(storeData);
  return store;
};

export default getStore;
